var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-dialog-container"},[(_vm.containerFlag)?[_c('v-dialog',{attrs:{"value":_vm.dialogFlag,"persistent":"","width":_vm.dialogWidth}},[_vm._t("default")],2)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }